export default __webpack_public_path__ + "static/media/miata.30a3a283.jpg";